import { render, staticRenderFns } from "./StudySummaryPanelContent.vue?vue&type=template&id=a79f3e70&scoped=true&lang=pug&"
import script from "./StudySummaryPanelContent.vue?vue&type=script&lang=ts&"
export * from "./StudySummaryPanelContent.vue?vue&type=script&lang=ts&"
import style0 from "./StudySummaryPanelContent.vue?vue&type=style&index=0&id=a79f3e70&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79f3e70",
  null
  
)

export default component.exports